module.exports = __webpack_public_path__ + "static/media/live04_01_2025.179160b6.jpg";